const routes = {
    start: '/',
    error: '/404',
    home: '/home',
    termsAndConditions:'/terms-and-conditions',

    auth: {
        login: '/login',
        register: '/signup',
        forgotPassword: '/forgot-password',
        otpVerification: '/otp-verification',
        resetPassword: '/reset-password',
        accessDenied: '/access-denied',
    },

    panel: {
        business: '/business',
        payment: '/payment',
        paymentById: (id) => `/payment/${id}`,
        dashboard: '/dashboard',
        appointment: '/appointment',
        reporting: '/reporting',
    },
};

export default routes;
